import { Card, Group, Stack, Text, Tooltip } from '@mantine/core';
import { IconInfoCircle } from '@tabler/icons-react';

type SummaryCardProps = {
  label: string;
  value: string;
  tooltip: string;
};

export function SummaryCard({ label, value, tooltip }: SummaryCardProps) {
  return (
    <Card p="md" radius="sm" withBorder>
      <Stack gap={4}>
        <Group gap={6}>
          <Text size="xs" c="dimmed" tt="uppercase" fw={600}>
            {label}
          </Text>
          <Tooltip label={tooltip} multiline maw={250}>
            <IconInfoCircle
              size={14}
              color="var(--mantine-color-dimmed)"
              style={{ cursor: 'help' }}
            />
          </Tooltip>
        </Group>
        <Text size="xl" fw={700}>
          {value}
        </Text>
      </Stack>
    </Card>
  );
}
